import React, { Component } from 'react'
import withNavigate from '../common/withNavigate'

import { whatsNewData }from '../data/whatsNewData'
import '../style/WhatsNew.scss'
import uuid from 'uuid'
import PropTypes from 'prop-types'
import Mixpanel from '../common/Mixpanel'
import { strings } from '../context/LanguageContext/strings'


class WhatsNew extends Component {

    componentDidMount(){
        Mixpanel.whatsNewViewed(this.props.screenOrientation)
    }

    componentWillUnmount(){
        Mixpanel.whatsNewClosed(this.props.screenOrientation)
    }

    render() {
        const onTabsClick = link => {
            switch(link){
            case 'Report':
                this.props.navigate('/app/reports')
                break
            case 'Troubleshoot':
                this.props.navigate('/app/help/guides')
                break
            case 'Feedback':
                this.props.navigate('/app/help/feedback')
                break
            default:
                break
            }            
        }
        
        return (
            <div className="wts-new-container" >
                {whatsNewData && whatsNewData.map(item  => {
                    const displayBtn = item.link !== null ? <button className={`${item.classname} btn`} onClick={() => onTabsClick(item.link) }>{strings.viewText}</button> : null
                    return(
                        <div key={uuid.v4()}>
                            <div className={item.classname}>{item.title}</div>
                            <div className={`${item.classname} relsd`}>{item.released}</div>
                            <div className={`${item.classname} desc`}>{item.description}</div>
                            <div className={`${item.classname} btn-container`}>{displayBtn}</div>
                        </div>
                    )
                }) }
            </div>
        )
    }
}

export default withNavigate(WhatsNew)

WhatsNew.propTypes = {
    screenOrientation: PropTypes.string,
    navigate: PropTypes.func.isRequired
}
